<template>
    <div id="business-profile-images-control">
        <div class="vx-row">
            <div class="vx-col w-full">
                <div class="mb-4 mt-4 w-full">
                    <vs-table stripe :data="images" pagination max-items="5" noDataText="No se han generado registros">
                        <template slot="header">
                            <h3>Imágenes de la empresa</h3>
                            <vs-button @click.stop="popupActivo = true" class="mb-2 mr-2" size="small" color="success">Agregar Imagen</vs-button>
                        </template>
                            <template slot="thead">
                            <vs-th class="bold"></vs-th>
                            <vs-th class="bold">NOMBRE DEL ARCHIVO</vs-th>
                            <vs-th class="bold">FECHA DE CREACIÓN</vs-th>
                            <vs-th class="bold">ACCIONES</vs-th>
                        </template>

                        <template slot-scope="{data}">
                            <vs-tr :key="indextr" v-for="(tr, indextr) in data">

                                <vs-td :data="data[indextr].storage_file">
                                    <img width="200" :src="`${URL}${projectId}/business_images/${tr.storage_file}`" :alt="`img_${indextr}`">
                                </vs-td>

                                <vs-td :data="data[indextr].storage_file">
                                    {{ tr.storage_file}}
                                </vs-td>
                                
                                <vs-td :data="indextr">
                                    {{ tr.created_at || "NA" }}
                                </vs-td>
                                
                                <vs-td :data="data[indextr].id">
                                    <div class="flex">
                                        <!-- <vs-button @click="verifyImageRequest(tr)" radius size="small" type="border" icon="check" color="success"></vs-button> -->
                                        <vs-button @click="deleteImageRequest(tr)" radius size="small" type="border" icon="delete" color="danger" class="ml-2"></vs-button>
                                    </div>
                                </vs-td>
                            </vs-tr>
                        </template>
                    </vs-table>
                </div>
            </div>
        </div>

        <vs-popup title="Agregar imágenes de la empresa" :active.sync="popupActivo">
            <div class="vx-row">
                <div class="vx-col">
                    <vx-card title="Nueva imagen de la empresa">
                        <p class="mb-2">Agrega múltiples imágenes de la empresa para mostrar en el detalle del crédito.</p>
                        <vs-divider></vs-divider>
                        <input
                            class="m-4"
                            ref="fileInput"
                            id="layout"
                            text="Seleccione las imágenes"
                            accept=".csv"
                            fileName="file" 
                            type="file" 
                            multiple="true"/> 
                        <div class="flex flex-wrap items-center justify-end">
                            <vs-button type="line" class="mt-4" @click="popupActivo = false">Cerrar</vs-button>
                            <vs-button class="ml-2 mt-4" @click="saveImagesRequest()">Guardar cambios</vs-button>
                        </div>
                    </vx-card>
                </div>
            </div>
        </vs-popup>
    </div>
</template>

<script>
import inputHelper from '@components/mixins/inputHelper';
const URL = "https://cdn.redgirasol.com/projects/"
export default {
    name: "business-profile-images-control",
    props: ["userId", "projectId", "businessProfileId"],
    mixins: [
        inputHelper
    ],
    data() {
        return {
            images: [],
            collections: {
                loan_guarantees: []
            },
            popupActivo: false,
            itemToDelete: null,
            URL: URL
        }
    },
    mounted() {
        this.getCurrentImages()
    },
    methods: {
        async getCurrentImages() {
            try {
                const res = await axios.get(`/api/get/business-profile-images/${this.businessProfileId}`);
                this.images = res.data;
            } catch (error) {
                console.log(error);
                this.showLoading(false);
            }
        },
        saveImagesRequest(item) {
            this.currentProjectFinanceId = item;
            this.$vs.dialog({
                type: 'alert',
                color: 'warning',
                title: "Guardar imágenes",
                text: "Se agregará las siguientes imágenes para el solicitante ¿Quiere continuar?",
                acceptText: "Aceptar",
                cancelText: 'Cancelar',
                accept: this.doRequestSave
            });
        },
        async doRequestSave() {
            try {
                this.showLoading(true);
                let doc = document.getElementById("layout");
                const data = new FormData();
                if(doc.files.length > 0){
                    this.showLoading(true);
                    for (let index = 0; index < doc.files.length; index++) {
                        const element = doc.files[index];
                        data.append("images[]",element);
                        
                    }
                    console.log(doc.files);
                    const res = await axios.post(`/api/business-profile/${this.projectId}/${this.userId}/upload`, data);
                    this.showLoading(false);
                    this.getCurrentImages();
                    this.saveSuccessNotif();
                } else {
                    this.warningNotif("Importante", "No se ha seleccionado ningún archivo.");
                }
            } catch (error) {
                console.error(error);
            } finally {
                this.showLoading(false);
            }
        },

        deleteImageRequest(item) {
            this.itemToDelete = item;
            this.$vs.dialog({
                type: 'alert',
                color: 'danger',
                title: "Borrar imagen",
                text: "Se eliminará la imagen de la empresa para el crédito ¿Quiere continuar?",
                acceptText: "Aceptar",
                cancelText: 'Cancelar',
                accept: this.doRequestDelete
            });
        },
        async doRequestDelete() {
            try {
                this.showLoading(true);
                const payload = {
                    document_file_id: this.itemToDelete.id
                    , project_id: this.projectId
                    , file_name: this.itemToDelete.storage_file
                }
                await axios.delete(`/api/delete/business-profile-images`, payload);
                this.getCurrentImages();
                this.showLoading(false);
            } catch (error) {
                this.showLoading(false);
            }
        },
        verifyImageRequest(item) {
            this.itemToDelete = item;
            this.$vs.dialog({
                type: 'alert',
                color: 'warning',
                title: "Verificar imagen",
                text: "Se verificará la imagen de la empresa para el crédito ¿Quiere continuar?",
                acceptText: "Aceptar",
                cancelText: 'Cancelar',
                accept: this.doRequestVerify
            });
        },
        async doRequestVerify() {
            try {
                this.showLoading(true);
                const payload = {
                    document_file_id: this.itemToDelete.id
                }
                await axios.post(`/api/post/business-profile-images/verify`, payload);
                this.getCurrentImages();
                this.showLoading(false);
            } catch (error) {
                this.showLoading(false);
            }
        },
        translateGuaranteeTypeEnum(type) {
            const types = {
                "real_real_state" :	"Bien inmueble",
                "real_property" :	"Bien mueble",
                "real_accounts_receivable" :	"Cuentas por cobrar",
                "personal_jointly_bound" :	"Obligado Solidario",
                "promissory_note" :	"Pagaré",
                "default" :	"No definido",
            };

            return (types[type] || types["default"]);
        }
    }

}
</script>

<style>
    .con-vs-dialog {
        z-index: 9999999 !important;
    }
</style>